<template>
    <div>
        <validation-observer ref="formObserver" v-slot="{ validate }">
            <b-form @submit.prevent="handleSubmit(validate)">
                <b-row>
                    <b-col md="6">
                        <house-info :form="form"/>
                    </b-col>

                    <b-col md="6">
                        <house-owner :form="form"/>
                        <house-price :form="form"/>
                        <house-amenity :form="form"/>
                        <house-comment v-if="house_id" />
                    </b-col>

                    <b-col cols="12" class="mt-1">
                        <b-button variant="primary" type="submit">
                            Submit
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
import {
    BRow, BCol, BButton, BForm,
} from 'bootstrap-vue';
import HouseInfo from './HouseInfo.vue';
import HouseOwner from './HouseOwner.vue';
import HousePrice from './HousePrice.vue';
import HouseAmenity from './HouseAmenity.vue';
import { ValidationObserver } from "vee-validate";
import axios from '@axios'
import router from '@/router'
import HouseComment from './HouseComment.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        BRow, BCol, HouseInfo, HouseOwner, HousePrice, HouseAmenity, BButton, ValidationObserver,
        BForm, HouseComment,
    },
    data() {
        const userStorage = JSON.parse(localStorage.getItem('userData'))

        return {
            house_id: router.currentRoute.params.id || null,
            form: {
                is_new_house: false,
                house_pin: {},
                house_pin_id: null,
                province_id: null,
                amphure_id: null,
                tambon_id: null,
                zip_code: null,
                house_type: null,
                house_no: null,
                floor: null,
                unit: null,
                plan_type: null,
                useable_area: null,
                land_area: null,
                bedroom: 0,
                bathroom: 0,
                parking: 0,
                furniture_id: null,
                action_id: null,
                status_id: null,
                expire_date: null,
                updated_date: new Date().toISOString().split('T')[0],
                meta_title: {},
                meta_description: {},
                youtube_url: null,
                comment: null,
                is_active: true,
                owner_id: null,
                amenity_id: [],
                sale_price: null,
                rent_price: null,
                created_by: userStorage?.id || null,
                updated_by: userStorage?.id || null,
                btsData: [],
                mrtData: [],
                airportLinkData: [],
                zoneId: [],
                amenities: [],
                newHousePinName: {},
                newHousePinAddress: {},
            },
        }
    },
    created() {
        if (this.house_id) {
            this.fetchExistingHouse()
        }
    },
    methods: {
        async fetchExistingHouse() {
            try {
                const { data } = await axios.get(`/v1/house/${this.house_id}`);
                if (data?.success && data?.data) {
                    const {
                        house_type_id, house_no, floor, unit, plan_type, area, bedroom, bathroom, parking, furniture_id,
                        action_id, status_id, expire_date, youtube_url, comment, is_active, owner_id, sale_price, rent_price,
                        created_by, meta_title, meta_description, amenity_id, updated_at, address, name: name2, house_address,
                        amenities, useable_area, land_area, is_new_house,
                    } = data.data;

                    Object.assign(this.form, {
                        house_type: house_type_id || null,
                        house_no: house_no || '',
                        floor: floor || null,
                        unit: unit || null,
                        plan_type: plan_type || null,
                        area: area || null,
                        bedroom: bedroom || 0,
                        bathroom: bathroom || 0,
                        parking: parking || 0,
                        furniture_id: furniture_id || null,
                        action_id: action_id || null,
                        status_id: status_id || null,
                        expire_date: expire_date || null,
                        updated_date: updated_at ? updated_at.split('T')[0] : null,
                        youtube_url: youtube_url || '',
                        comment: comment || '',
                        is_active: !!is_active,
                        owner_id: owner_id || null,
                        sale_price: sale_price || null,
                        rent_price: rent_price || null,
                        created_by: created_by || null,
                        meta_title: meta_title || {},
                        meta_description: meta_description || {},
                        amenity_id: amenity_id || [],
                        house_pin_id: address?.house_pin_id || null,
                        province_id: address?.province_id || null,
                        amphure_id: address?.amphure_id || null,
                        tambon_id: address?.district_id || null,
                        zip_code: address?.zip_code || null,
                        btsData: address?.btsData || [],
                        mrtData: address?.mrtData || [],
                        airportLinkData: address?.airportLinkData || [],
                        zoneId: address?.zone || [],
                        newHousePinName: name2 || {},
                        newHousePinAddress: house_address || {},
                        amenities: amenities || [],
                        land_area: land_area || null,
                        useable_area: useable_area || null,
                        is_new_house: !!is_new_house,
                    });
                    this.form.house_pin.isNew = address?.house_pin_id !== null ? false : true;
                }
            } catch (err) {
                console.error('Failed to fetch house:', err);
                this.showToast('danger', 'AlertTriangleIcon', 'Error', 'Failed to load house data');
            }
        },
        async handleSubmit(validate) {
            const isValid = await validate();
            if (!isValid) {
                this.showToast('danger', 'AlertTriangleIcon', 'Error', 'Please fill required fields');
                return;
            }

            const payload = {
                ...this.form,
                amenities: this.form.amenities.filter(a => a.show_frontend || a.show_key_feature),
            };

            if (!this.house_id) {
                try {
                    await axios.post('v1/house/add', payload);
                    this.showToast('success', 'CheckIcon', 'Success', 'House added successfully');
                } catch (error) {
                    this.showToast('danger', 'AlertTriangleIcon', 'Error', `Add house failed: ${error}`);
                }
            } else {
                try {
                    await axios.post('v1/house/update', { ...payload, id: this.house_id });
                    this.showToast('success', 'CheckIcon', 'Success', 'House updated successfully');
                } catch (error) {
                    this.showToast('danger', 'AlertTriangleIcon', 'Error', `Update house failed: ${error}`);
                }
            }
        },
        showToast(variant, icon, title, text) {
            this.$toast({
                component: ToastificationContent,
                props: { title, text, icon, variant },
            })
        },
    },
}
</script>